import React from 'react'
import { useTranslation } from 'react-i18next';
interface Member {
    id: number
    full_name: string
    function: string
    image: string
    facebook: string
    instagram: string
    twitter: string
    youtube: string

}

function Team({items}) {
    const { t } = useTranslation();
    function member(item:Member) {
        return(
            <div key={item.id} className="col-12 col-md-6 col-lg-3">
                <div className="knsl-team-card">
                <div className="knsl-photo-frame">
                    <img src={item.image} alt={`${item.full_name} - ${item.function}`} />
                </div>
                <div className="knsl-team-member-descr">
                    <h3 className="knsl-mb-10">{item.full_name}</h3>
                    <div>{t(`main.${item.function}`)}</div>
                    <ul className="knsl-member-social">
                    <li><a href={item.facebook}><i className="fab fa-facebook-f"></i></a></li>
                    <li><a href={item.instagram}><i className="fab fa-instagram"></i></a></li>
                    <li><a href={item.twitter}><i className="fab fa-twitter"></i></a></li>
                    <li><a href={item.youtube}><i className="fab fa-youtube"></i></a></li>
                    </ul>
                </div>
                </div>
            </div>
        )
    }

    return(
        <section className="knsl-p-0-80">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="knsl-center knsl-title-frame knsl-mb-100">
                        <h2 className="knsl-mb-20">{t('main.ourTeam')}</h2>
                        <p>{t('main.ourTeamDesc')}</p>
                        </div>
                    </div>
                    {items.map((item:Member) => member(item))}
                </div>
            </div>
        </section>
    )   
}

export default Team